var _circle, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTroubleshootingEmptyState = function SvgTroubleshootingEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 276,
    viewBox: "0 0 320 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.42,
    cx: 161.329,
    cy: 137.558,
    r: 137.558,
    fill: "#C5CEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1660_11176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.3525,
    y: 104.277,
    width: 266.806,
    height: 61.9109,
    rx: 14.0037,
    fill: "white",
    stroke: "#EEEEEE",
    strokeWidth: 1.47407
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3037 138.866L60.8046 126.177C59.7969 124.47 58.441 123.555 56.9764 123.594C55.5117 123.633 54.2066 124.619 53.2913 126.377L46.4792 139.448C45.6174 141.116 45.5589 142.695 46.3187 143.917C47.0785 145.138 48.5278 145.782 50.4062 145.732L64.7173 145.35C66.5956 145.3 68.0085 144.58 68.7022 143.32C69.3958 142.059 69.2529 140.474 68.3037 138.866ZM56.3466 131.442C56.3343 130.984 56.7043 130.594 57.1627 130.582C57.6211 130.569 58.0114 130.939 58.0237 131.398L58.1727 136.988C58.185 137.446 57.815 137.837 57.3566 137.849C56.8982 137.861 56.5079 137.491 56.4957 137.033L56.3466 131.442ZM58.2387 141.137C58.1839 141.183 58.1292 141.23 58.0745 141.276C58.0086 141.322 57.9424 141.358 57.876 141.382C57.8098 141.417 57.7433 141.441 57.6653 141.455C57.5985 141.468 57.5206 141.481 57.4535 141.483C57.3864 141.484 57.3078 141.475 57.2293 141.466C57.1619 141.457 57.0942 141.436 57.0262 141.405C56.9586 141.384 56.8906 141.352 56.8223 141.309C56.7652 141.266 56.7081 141.223 56.651 141.18C56.4441 140.972 56.3134 140.685 56.3056 140.394C56.2979 140.104 56.4131 139.81 56.6087 139.592C56.6634 139.546 56.7181 139.499 56.7728 139.453C56.8387 139.407 56.9049 139.371 56.9714 139.347C57.0376 139.312 57.104 139.288 57.1708 139.275C57.3153 139.237 57.4718 139.233 57.6069 139.263C57.6854 139.272 57.7531 139.293 57.8211 139.325C57.8888 139.345 57.9568 139.377 58.025 139.42C58.0821 139.463 58.1392 139.506 58.1963 139.55C58.4032 139.757 58.534 140.044 58.5417 140.335C58.5495 140.625 58.4342 140.919 58.2387 141.137Z",
    fill: "#FFCDD2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4226,
    y: 122.703,
    width: 53.0665,
    height: 8.84441,
    rx: 4.42221,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4226,
    y: 140.392,
    width: 106.133,
    height: 8.84441,
    rx: 4.42221,
    fill: "#F5F5F5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1660_11176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.8462,
    y: 49.8,
    width: 266.806,
    height: 61.9109,
    rx: 14.0037,
    transform: "rotate(5.12869 33.8462 49.8)",
    fill: "white",
    stroke: "#EEEEEE",
    strokeWidth: 1.47407
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5369 89.8732L70.5373 76.4101C69.7313 74.5987 68.489 73.5349 67.0295 73.4063C65.5699 73.2777 64.1607 74.1078 63.0503 75.7503L54.7889 87.9569C53.7421 89.5152 53.5034 91.0772 54.1187 92.3778C54.7339 93.6783 56.1001 94.4835 57.9718 94.6485L72.2328 95.9051C74.1045 96.07 75.5905 95.5161 76.4237 94.3432C77.2569 93.1703 77.296 91.5794 76.5369 89.8732ZM65.5066 81.1316C65.5469 80.6748 65.9591 80.3294 66.4159 80.3696C66.8727 80.4099 67.2181 80.8221 67.1778 81.2789L66.687 86.8495C66.6467 87.3063 66.2345 87.6518 65.7777 87.6115C65.321 87.5713 64.9755 87.1591 65.0158 86.7023L65.5066 81.1316ZM66.2782 90.9791C66.2186 91.0187 66.1589 91.0584 66.0993 91.098C66.0285 91.1367 65.9587 91.1642 65.8899 91.1806C65.8201 91.2082 65.7513 91.2246 65.6723 91.2288C65.6045 91.2341 65.5255 91.2384 65.4587 91.2325C65.3918 91.2266 65.3148 91.2086 65.2378 91.1905C65.172 91.1735 65.1071 91.1453 65.0432 91.106C64.9783 91.0779 64.9144 91.0385 64.8515 90.9881C64.7997 90.9386 64.7479 90.8891 64.6961 90.8397C64.5142 90.6103 64.4172 90.3098 64.4427 90.0202C64.4682 89.7305 64.6163 89.4516 64.8355 89.2576C64.8952 89.2179 64.9548 89.1783 65.0144 89.1386C65.0852 89.0999 65.155 89.0724 65.2238 89.056C65.2936 89.0285 65.3624 89.0121 65.4302 89.0068C65.578 88.9862 65.734 88.9999 65.8648 89.0451C65.9418 89.0631 66.0066 89.0913 66.0706 89.1306C66.1354 89.1588 66.1993 89.1981 66.2623 89.2486C66.314 89.298 66.3658 89.3475 66.4176 89.397C66.5995 89.6263 66.6965 89.9268 66.671 90.2165C66.6455 90.5062 66.4974 90.785 66.2782 90.9791Z",
    fill: "#FFCDD2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.0007,
    y: 74.1475,
    width: 53.0665,
    height: 8.84441,
    rx: 4.42221,
    transform: "rotate(5.12869 99.0007 74.1475)",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.4194,
    y: 91.7659,
    width: 106.133,
    height: 8.84441,
    rx: 4.42221,
    transform: "rotate(5.12869 97.4194 91.7659)",
    fill: "#F5F5F5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1660_11176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.3084,
    y: 163.75,
    width: 266.806,
    height: 61.9109,
    rx: 14.0037,
    transform: "rotate(-4.85076 28.3084 163.75)",
    fill: "white",
    stroke: "#EEEEEE",
    strokeWidth: 1.47407
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6211 195.972L66.1107 183.938C64.9669 182.319 63.5409 181.518 62.0843 181.676C60.6277 181.835 59.4075 182.924 58.6389 184.751L52.9171 198.335C52.1944 200.067 52.265 201.646 53.1221 202.802C53.9792 203.957 55.4762 204.48 57.3442 204.277L71.5763 202.728C73.4443 202.524 74.7937 201.691 75.382 200.378C75.9704 199.066 75.6985 197.498 74.6211 195.972ZM62.0977 189.55C62.048 189.094 62.3849 188.675 62.8408 188.625C63.2967 188.576 63.7159 188.913 63.7655 189.369L64.3707 194.928C64.4203 195.384 64.0834 195.803 63.6275 195.853C63.1717 195.902 62.7525 195.565 62.7028 195.109L62.0977 189.55ZM64.7752 199.058C64.7245 199.108 64.6737 199.159 64.623 199.209C64.5611 199.261 64.498 199.302 64.4337 199.331C64.3706 199.372 64.3063 199.401 64.2297 199.421C64.1642 199.439 64.0876 199.459 64.0209 199.466C63.9542 199.474 63.8751 199.471 63.7961 199.468C63.7282 199.464 63.659 199.449 63.5887 199.423C63.5196 199.408 63.4492 199.382 63.3777 199.345C63.3172 199.307 63.2568 199.268 63.1964 199.23C62.9732 199.04 62.8194 198.765 62.788 198.475C62.7565 198.186 62.8473 197.884 63.0245 197.651C63.0752 197.6 63.126 197.55 63.1767 197.499C63.2386 197.448 63.3017 197.407 63.366 197.377C63.4291 197.337 63.4934 197.307 63.5589 197.289C63.6998 197.24 63.8554 197.223 63.9925 197.242C64.0715 197.244 64.1407 197.259 64.211 197.285C64.2802 197.3 64.3505 197.327 64.4221 197.364C64.4825 197.402 64.5429 197.441 64.6034 197.479C64.8265 197.668 64.9803 197.944 65.0117 198.233C65.0432 198.522 64.9524 198.825 64.7752 199.058Z",
    fill: "#FFCDD2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.6965,
    y: 176.438,
    width: 53.0665,
    height: 8.84441,
    rx: 4.42221,
    transform: "rotate(-4.85076 96.6965 176.438)",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1924,
    y: 194.064,
    width: 106.133,
    height: 8.84441,
    rx: 4.42221,
    transform: "rotate(-4.85076 98.1924 194.064)",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1660_11176",
    x: 0.978514,
    y: 96.1699,
    width: 309.554,
    height: 104.659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.2666
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1660_11176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1660_11176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1660_11176",
    x: 8.13257,
    y: 42.8875,
    width: 311.631,
    height: 125.872,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.2666
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1660_11176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1660_11176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1660_11176",
    x: 8.06763,
    y: 134.215,
    width: 311.568,
    height: 124.732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.2666
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1660_11176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1660_11176",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTroubleshootingEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "troubleshooting-empty-state.bc4c5402c00692863bda510e57bb01b7.svg";